/** 字符串格式化与清洗工具 */

/**
 * 剥离字符串里的 HTML 标签，只保留纯文本。
 *
 * 用于清洗后端字段被污染的情况：部分酒店 / 订单的 address、location 字段
 * 里夹带了未渲染的 HTML 标签（如 `<span class="components_itemDescTag__...">健身房</span>`），
 * 直接渲染会把整段字符串原样输出。用本函数可安全降级为纯文本。
 */
export function stripHtml(s: string | null | undefined): string {
  if (!s) return "";
  return s
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}
